<template>
    <div class="text-center">
        <v-overlay :model-value="overlay" class="align-center justify-center">
            <v-progress-circular color="primary" indeterminate size="64" :width="8"></v-progress-circular>
        </v-overlay>
    </div>
</template>
  
<script>
export default {
    name: "LoadingView",
    props: {},
    components: {},
    data() {
        return {
            overlay: true,
        };
    }
};
</script>
  